import { render, staticRenderFns } from "./MHeader.vue?vue&type=template&id=5af70e26&scoped=true&"
import script from "./MHeader.vue?vue&type=script&lang=js&"
export * from "./MHeader.vue?vue&type=script&lang=js&"
import style0 from "./MHeader.vue?vue&type=style&index=0&id=5af70e26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af70e26",
  null
  
)

export default component.exports